import { X } from "react-feather";
import { Incidents } from "../../../../service/models/complaint_model";
import { formatDateWithOrdinal } from "../../content_panel/utils/helpers";

interface ViewIncidentModalProps {
  incident: Incidents | null;
  isOpen: boolean;
  onClose: () => void;
}
const ViewIncidentModal: React.FC<ViewIncidentModalProps> = ({
  incident,
  isOpen,
  onClose,
}) => {
  if (!isOpen || !incident) return null;

  return (
    <div id="incident_tracker_view_incident_modal" className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">View Incident</h2>
          <button
            id="incident_tracker_view_incident_modal_close_btn"
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <X size={24} />
          </button>
        </div>
        <div className="space-y-4">
          <div>
            <strong>Service Desk ID:</strong> {incident?.serviceDeskId}
          </div>
          <div>
            <strong>Complaint ID:</strong> {incident?.complaintId ?? "--"}
          </div>
          <div>
            <strong>Complainant Name:</strong>{" "}
            {incident?.complainant_name ?? "--"}
          </div>
          <div>
            <strong>Organization Name:</strong>{" "}
            {incident?.complainant_org ?? "--"}
          </div>
          <div>
            <strong>Complainant State:</strong>{" "}
            {incident?.complainant_state ?? "--"}
          </div>
          <div>
            <strong>Phone Number:</strong>{" "}
            {incident?.complainant_number ?? "--"}
          </div>
          <div>
            <strong>Status:</strong>{" "}
            <span
              className={`px-2 py-1 rounded text-sm ${
                incident.status.toLowerCase() === "open"
                  ? "bg-yellow-100 text-yellow-800"
                  : incident.status.toLowerCase() === "resolved"
                  ? "bg-green-100 text-green-800"
                  : incident.status.toLowerCase() === "escalated"
                  ? "bg-red-100 text-red-800"
                  : "bg-gray-100 text-gray-800"
              }`}
            >
              {incident?.status ?? "--"}
            </span>
          </div>
          <div>
            <strong>Complaint Related To:</strong>{" "}
            {incident?.complaint_related_to ?? "--"}
          </div>
          <div>
            <strong>Sub-category Related To:</strong>{" "}
            {incident?.subcategory_of_related_to ?? "--"}
          </div>
          <div>
            <strong>Remark:</strong> {incident?.remark ?? "--"}
          </div>
          <div>
            <strong>Created At:</strong>{" "}
            {formatDateWithOrdinal(incident?.dateIncidentCreatedAt)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewIncidentModal;
